import script from "./SwipeItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SwipeItem.vue?vue&type=script&setup=true&lang=js"

import "./SwipeItem.vue?vue&type=style&index=0&id=e3b391e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3b391e2"]])

export default __exports__